export default __webpack_public_path__ + "static/media/vijaywadaDeitieOne.16be5ef8.png";